import { useEffect, useState } from "react";
import "./index.scss";
import { Form, Input, Toast, Radio, Space } from 'antd-mobile'
import CustomScroll from '@src/component/customScroll'
import BottomIcon from '@src/component/bottomIcon'
import DealerDoorAreaSelector from '@src/component/DealerDoorAreaSelector'
import { getCarIns, getCFDealerDoor, carInsSubmit } from "@service/applyFormSubService"
import VehicleSelector from "@component/VehicleSelector";
import PickerPopup from "@src/component/PickerPopup";
import { brandName } from '@src/config'
import store from '@src/util/store'
import { goto } from "@src/route";
import ProgressBar from "@src/component/ProgressBar";
import { verifyPhone, verifyIdentify, isEmpty } from "@src/util";
import PickFengzhuang from '@src/component/PickFengzhuang'
import { point, periods } from "@src/assets/JSON/Picker.json";
import SimulationInput from "@src/component/SimulationInput";
export default function Index() {
  const [form] = Form.useForm(); //表单数据
  const [dealerList, setDealerList] = useState([]) // 经销商列表
  const [dealerid, setDealerid] = useState() // 资格预审经销商
  const [val, setVal] = useState<number[]>([]); //首付比例与期数值
  const [visiblePopup, setVisiblePopup] = useState<boolean>(false) // 显示分期期数
  const [formData, setFormData] = useState<any>({})
  const [visibleDealer, setVisibleDealer] = useState<boolean>(false) // 显示经销商选择
  const [visibleVeh, setVisibleVeh] = useState<boolean>(false) // 显示车辆
  const loanid = store.get('loanid')

  // 设置title
  useEffect(() => {
    document.title = "车辆和分期信息";
    form.setFieldsValue({
      brandName: brandName
    })
  }, [])
  // 获取经销商数据
  useEffect(() => {
    getCFDealerDoor().then(res => {
      const list = (res || []).map((res: any) => {
        res.label = res.storeName
        res.value = res.id
        return res
      })
      setDealerList(list || [])
    }).catch(err => {
      Toast.show(err?.errmsg || '经销商数据获取失败！')
    })
  }, [])
  // 资格预审设置经销商名称
  useEffect(() => {
    if (dealerid && dealerList.length) {
      const find = dealerList.find((res: any) => res.id == dealerid) as any
      if (find?.id) {
        form.setFieldsValue({
          carDealerName: find.storeName
        })
      }
    }
  }, [dealerList, dealerid])
  // 回填数据
  useEffect(() => {
    // 获取提交数据
    getCarIns(loanid).then(res => {
      if (res) {
        if (res.netPrice > 0) {
          if (res.taxAmount > 0) {
            res.isPayGZ = 1
          } else {
            res.isPayGZ = 0
          }
        }
        for (const key in res) {
          if (isEmpty(res[key])) {
            delete res[key]
          }
        }
        setFormData(res)
        form.setFieldsValue(res)
        if (!isEmpty(res.firstPaidRate) && !isEmpty(res.periods)) {
          setVal([res.firstPaidRate, res.periods])
        }
        getAmount()
        if (res.dealerid && !res.carDealerName) {
          setDealerid(res.dealerid)
        }
      }
    }).catch(err => {
      err?.errmsg && Toast.show(err?.errmsg)
    })
  }, [])

  /**
   * 计算分期购置税
   * 裸车价+购置税/11.3取整
   */
  const getTaxAmount = () => {
    const price = form.getFieldsValue(['netPrice']).netPrice || 0
    form.setFieldsValue({
      taxAmount: Math.ceil(price / 11.3)
    })
  }
  /**
   * 计算总价
   * 裸车价+购置税 - 自付款
   */
  const getAmount = () => {
    getSelfPayAmount()
    getTaxAmount()
    const formData2: any = form.getFieldsValue(['netPrice', 'firstPaidRate', 'isPayGZ', 'taxAmount'])
    const netPrice: number = Number(formData2.netPrice) || 0
    const firstPaidRate = Number(((formData2.firstPaidRate || 0) * netPrice).toFixed(2))
    const tax: number = formData2.isPayGZ == 1 ? Number(formData2.taxAmount) : 0;
    let amount = netPrice + tax - firstPaidRate;
    amount = Math.ceil(amount)
    form.setFieldsValue({
      amount
    })
  }
  /**
     * 计算自付款
     * 裸车价*首付比例
     */
  const getSelfPayAmount = () => {
    const formData2: any = form.getFieldsValue(['netPrice', 'firstPaidRate'])
    const netPrice: number = Number(formData2.netPrice) || 0
    form.setFieldsValue({
      selfPayAmount: ((formData2.firstPaidRate || 0) * netPrice).toFixed(2)
    })
  }
  // 提交
  const subClick = () => {
    form.validateFields().then(res => {
      res.loanid = loanid
      if (res.isPayGZ == 0) {
        res.taxAmount = 0
      }
      Toast.show({
        icon: 'loading',
        content: '加载中…',
        duration: 0,
        maskClickable: false
      })
      carInsSubmit(res).then(() => {
        Toast.clear()
        goto('/apply/w4')
      }).catch(err => {
        Toast.show(err?.errmsg || '数据保存失败！')
      })
    })
  }
  // 设置价格
  const netPriceChange = (e: any) => {
    if (e < 30000 && form.getFieldsValue(['periods']).periods == 36) {
      form.setFieldsValue({
        periods: ''
      })
    }
  }
  return (<><div className="page bottomFit VehstageInformation">
    <header>
      <ProgressBar point={80} />
    </header>
    <CustomScroll>
      <div className="top-box">
        <div className="float-box"></div>
        <Form form={form} layout='horizontal' onValuesChange={() => {
          setFormData(form.getFieldsValue(true))
          getAmount()
        }}>
          <div className="form-Box">
            <div className="adm-list-item-content-prefix-134">
              <div className="title">
                <h1 className="dotted-line">车辆信息</h1>
                <p>信息真实，通过率<span>提升90%</span></p>
              </div>
              <div className="inputForm">
                <Form.Item name="brandName" label='品牌名称：'>
                  <Input maxLength={30} placeholder='品牌名称' readOnly />
                </Form.Item>
                <div className="more-xia">
                  <Form.Item name="carDealerName" label='经销商名称：' arrow={false} onClick={() => { setVisibleDealer(true) }} rules={[{ required: true, message: '请选择经销商' }]}>
                    <SimulationInput placeholder='请选择经销商' />
                  </Form.Item>
                </div>
                <div className="more-xia">
                  <Form.Item name="vehicleName" label='车型名称：' arrow={false} onClick={() => { setVisibleVeh(true) }} rules={[{ required: true, message: '请选择车型' }]}>
                    <SimulationInput placeholder='请选择车型' />
                  </Form.Item>
                </div>
                <Form.Item name="netPrice" label='裸车价：' rules={[{ required: true, message: '请输入车辆净价' }]}>
                  <Input type="number" max={9999999} placeholder='请输入车辆净价' onChange={(e) => { netPriceChange(e) }} />
                </Form.Item>
                <div className="conceal-inputting">
                  <Form.Item name="modelId">
                    <Input />
                  </Form.Item>
                  <Form.Item name="quotedPrice">
                    <Input />
                  </Form.Item>
                  <Form.Item name="dealerid">
                    <Input />
                  </Form.Item>
                </div>
                <div className="adm-list-item-content-prefix-144">
                  <Form.Item name="isSelf" label='车辆是否登记本人：' rules={[{ required: true, message: '车辆是否登记本人' }]}>
                    <Radio.Group>
                      <Space direction='horizontal' style={{ '--gap': '63px' }}>
                        <Radio value={1} icon={checked => checked ? (<div className="checked" />) : (<div className="no-checked" />)}>是</Radio>
                        <Radio value={0} icon={checked => checked ? (<div className="checked" />) : (<div className="no-checked" />)}>否</Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                </div>
                {formData?.isSelf == 0 && <>
                  <div className="adm-list-item-content-prefix-144">
                    <Form.Item name="type" label='背户类型：' rules={[{ required: true, message: '请选择背户类型' }]}>
                      <Radio.Group>
                        <Space direction='horizontal' style={{ '--gap': '49px' }}>
                          <Radio value={1} icon={checked => checked ? (<div className="checked" />) : (<div className="no-checked" />)}>个人</Radio>
                          <Radio value={2} icon={checked => checked ? (<div className="checked" />) : (<div className="no-checked" />)}>公司</Radio>
                        </Space>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                  {formData?.type == 2 && <Form.Item name="company" label='背户公司名称：' rules={[{ required: true, message: '请输入背户公司名称' }]}>
                    <Input maxLength={30} placeholder='请输入背户公司名称' />
                  </Form.Item>}
                  {formData?.type == 1 && <>
                    <Form.Item name="name" label='背户人姓名：' rules={[{ required: true, message: '请输入背户人姓名' }, { min: 2, max: 20, message: "姓名长度为2-20" }]}>
                      <Input maxLength={20} placeholder='请输入背户人姓名' />
                    </Form.Item>
                    <div className="adm-list-item-content-prefix-115">
                      <Form.Item name="identifyNumber" label='背户人身份证号：' rules={[{ validator: verifyIdentify }]}>
                        <Input maxLength={18} placeholder='请输入背户人身份证号' />
                      </Form.Item>
                      <Form.Item name="mobile" label='背户人手机号码：' rules={[{ validator: verifyPhone }]}>
                        <Input type="number" placeholder='请输入背户人手机号码' onChange={() => {
                          form.setFieldsValue({
                            mobile: form.getFieldValue('mobile').replace(/\D/g, '').substring(0, 11)
                          })
                        }} />
                      </Form.Item>
                    </div>
                  </>}
                </>}
              </div>
            </div>
          </div>
          <div className="form-Box">
            <div className="adm-list-item-content-prefix-134">
              <div className="title">
                <h1 className="dotted-line">分期信息</h1>
                <p>信息真实，通过率<span>提升90%</span></p>
              </div>
              <div className="inputForm">
                <div className="adm-list-item-content-prefix-144">
                  <Form.Item name="isPayGZ" label='是否分期购置税：' rules={[{ required: true, message: '请选择是否分期购置税' }]}>
                    <Radio.Group>
                      <Space direction='horizontal' style={{ '--gap': '63px' }}>
                        <Radio value={1} icon={checked => checked ? (<div className="checked" />) : (<div className="no-checked" />)}>是</Radio>
                        <Radio value={0} icon={checked => checked ? (<div className="checked" />) : (<div className="no-checked" />)}>否</Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>
                </div>
                {form.getFieldsValue(['isPayGZ']).isPayGZ == 1 && <div className="more-unit"><Form.Item name="taxAmount" label='购置税款：'>
                  <Input readOnly type="number" />
                </Form.Item></div>}
                <div className="more-xia">
                  <Form.Item name="periods" label='分期期数：' onClick={() => { setVisiblePopup(true) }} arrow={false} rules={[{ required: true, message: '请选择分期期数' }]}>
                    <PickFengzhuang placeholder='请选择分期期数' disabled columns={periods.filter(res => formData.netPrice < 30000 ? res.value < 36 : true)} />
                  </Form.Item>
                </div>
                <div className="more-xia">
                  <Form.Item name="firstPaidRate" label='首付比例：' onClick={() => { setVisiblePopup(true) }} arrow={false} rules={[{ required: true, message: '请选择首付比例' }]}>
                    <PickFengzhuang placeholder='请选择首付比例' disabled columns={point} />
                  </Form.Item>
                </div>
                <div className="more-unit">
                  <Form.Item name="selfPayAmount" label='自付车款金额：'>
                    <Input readOnly type="number" />
                  </Form.Item>
                </div>
                <div className="more-unit">
                  <Form.Item name="amount" label='实际申请分期金额：'>
                    <Input readOnly type="number" />
                  </Form.Item>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <footer>
        <div className="button-them submit" onClick={subClick}>下一步</div>
      </footer>
      <BottomIcon />
    </CustomScroll>
    <PickerPopup visible={visiblePopup} setVisible={setVisiblePopup} value={val} carPrice={formData.netPrice} setVal={(e: any) => {
      form.setFieldsValue({
        periods: e[1],
        firstPaidRate: e[0]
      })
      getAmount()
      setVal(e)
      setFormData(form.getFieldsValue(true))
    }} />

  </div><DealerDoorAreaSelector onClose={() => { setVisibleDealer(false) }} onConfirm={(res) => {
    form.setFieldsValue({
      dealerid: res.id,
      carDealerName: res.storeName
    })
    setVisibleDealer(false)
    setFormData(form.getFieldsValue(true))
  }} visible={visibleDealer} list={dealerList} />
    <VehicleSelector onClose={() => { setVisibleVeh(false) }} onConfirm={(data) => {
      form.setFieldsValue({
        vehicleName: data.vehicleFullName,
        netPrice: data.salePrice,
        modelId: data.id,
        quotedPrice: data.salePrice,
      })
      netPriceChange(data.salePrice)
      getAmount()
      setVisibleVeh(false)
      setFormData(form.getFieldsValue(true))
    }} visible={visibleVeh} />
  </>)
}
